import React, { Component } from "react";
import SuccessImage from "../images/SuccessImage";

export class Success extends Component {
  componentWillMount = () => {
    setTimeout(() => {
      console.debug("Triggering Modal Close");
      window.parent.postMessage("modal.close", "*");
    }, 10000);
  };

  render() {
    return (
      <React.Fragment>
        <div className="text-center">
          <SuccessImage />
          <h1>Appointment Confirmed !</h1>
          <small>We will send you a confirmation email on given email address. Thank you for booking with us.</small>
        </div>
      </React.Fragment>
    );
  }
}

export default Success;
